import React from "react"

export default class Terms extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div className="container" style={{marginTop:"47.5px",marginBottom:"47.5px"}}>
                <article className="p-3">
                    {/* <h4>TERMINI E CONDIZIONI</h4>
                    <p>
                        Da questa pagina è possibile pagare una sanzione amministrativa. Per cercare un verbale o una ingiunzione, va inserito il codice univoco presente sull'atto giudiziario e il testo mostrato a video ("Captcha"), prima di confermare.
                    </p>
                    <h4>PAGAMENTO DI UN VERBALE</h4>
                    <p>
                        Il sistema calcola automaticamente l'importo dovuto sulla base del tempo decorso dall'effettiva contestazione o notificazione dell'accertamento e/o dell'ingiunzione di pagamento.
                        Il pagamento del verbale entro il 60° giorno consente di pagare il 50% della sanzione, maggiorata delle spese; l'importo si riduce ulteriormente al 30% se il pagamento avviene entro il 5° giorno successivo alla contestazione o alla notifica.
                        Il pagamento di quanto dovuto entro il 60° giorno successivo alla contestazione o alla notifica comporta l'estinzione dell'obbligazione.
                    </p>
                    <h4>PAGAMENTO DI UN'ORDINANZA INGIUNZIONE</h4>
                    <p>
                        Il pagamento di un'ordinanza ingiunzione va effettuato entro 30 giorni dalla data di notifica dell'atto. 
                        L'importo è comprensivo della sanzione intera e delle spese di notificazione fino a quel momento sostenute. Il pagamento dell'ordinanza secondo l'importo dovuto entro il 30° giorno successivo alla notifica comporta l'estinzione dell'obbligazione.
                    </p>
                    <h4>PAGAMENTI PARZIALI</h4>
                    <p>
                        In caso di pagamento di un importo inferiore a quanto dovuto, il versamento non avrà valore ai fini dell’estinzione dell’obbligazione e l’importo versato sarà considerato in acconto, comportando l’iscrizione a ruolo per la sanzione intera oltre le spese, detratta dell’acconto versato.
                    </p>
                    <h4>METODI DI PAGAMENTO</h4>
                    <p>
                        Il pagamento può essere effettuato con carte bancarie dei circuiti Mastercard, Visa ed American Express. In caso di pagamento andato a buon fine, viene rilasciata apposita ricevuta di pagamento in formato *.pdf.
                    </p> */}
                </article>
            </div>
        )
    }
}